/*
var vendors = ['-moz-', '-webkit-', '-o-', '-ms-', '-khtml-', ''];

function toCamelCase(str) {
	return str.toLowerCase().replace(/(\-[a-z])/g, function ($1) {
		return $1.toUpperCase().replace('-', '');
	});
};

function setCss3Style(el, prop, val) {
	for (var i = 0, l = vendors.length; i < l; i++)
		el.style[toCamelCase(vendors[i] + prop)] = val;
};
*/

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function (global) {
	'use strict';
	if (!global.console) {
		global.console = {};
	}
	var con = global.console;
	var prop, method;
	var dummy = function () {
	};
	var properties = ['memory'];
	var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
		'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
		'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn,timeLog,trace').split(',');
	while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
	while (method = methods.pop()) if (!con[method]) con[method] = dummy;
	// Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);



